/**
 * Environment configuration
 * Contains application-wide configuration values
 */

export const environment = {
  // Authentik OAuth2 Configuration
  // Note: Replace these with your actual Authentik instance URLs and client ID
  authentikClientId: 'Ub3i5eaZ0fxJDsyvpvydBcDsl8CDnXoon7gEb5Yx',
  authentikAuthorizationEndpoint:
    'https://auth.staging.leadconnectorhq.com/application/o/authorize/',
  authentikTokenEndpoint: 'https://auth.staging.leadconnectorhq.com/application/o/token/',
  authentikUserInfoEndpoint: 'https://auth.staging.leadconnectorhq.com/application/o/userinfo/',
  authentikLogoutEndpoint:
    'https://auth.staging.leadconnectorhq.com/application/o/internal-devtools/end-session/',
  authentikScope: 'openid profile email offline_access',

  // Authentication Configuration
  auth: {
    cookieName: 'ghl_auth',
    expirationDays: 7,
    allowedDomain: 'gohighlevel.com'
  },

  // API Configuration
  api: {
    baseUrl: 'https://api.gohighlevel.com',
    timeout: 30000, // milliseconds
    retryAttempts: 3,
    endpoints: {
      userProfile: '/v1/users/profile',
      settings: '/v1/settings'
    }
  },

  // Feature Flags
  features: {
    enableDarkMode: true,
    enableNotifications: true,
    enableAnalytics: true
  },

  // Error Reporting
  errorReporting: {
    enabled: true,
    sampleRate: 1.0,
    ignorePatterns: ['Network Error', 'User cancelled']
  }
} as const

export type Environment = typeof environment
